<template>
    <v-form class="mt-5 mb-5">
        <v-container v-if="user != null">
            <v-row class="border-bottom">
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.phone"
                            :label="language.lang('Phone number')"
                            disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            disabled
                            v-model="user.email"
                            :label="language.lang('Email')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.username"
                            :label="language.lang('Username')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.password"
                            :label="language.lang('Change Password')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.user_profile.birthday"
                            :label="language.lang('Birthday')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-textarea
                            v-model="user.user_profile.bio"
                            :label="language.lang('Bio')"
                    ></v-textarea>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-radio-group class="text-center justify-center align-center" v-model="user.user_profile.gender"
                                   row>
                        <v-radio class="text-center justify-center align-center"
                                 :label="language.lang('Male')"
                                 value="0"
                        ></v-radio>
                        <v-radio class="text-center justify-center align-center"
                                 :label="language.lang('Female')"
                                 value="1"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <div :class="!isEN ? 'text-left' : 'text-right'">
                <base-button tag="span" @click="editProfile"
                             type="default" class="m-1 mt-4">
                    {{language.lang('Set Profile')}}
                </base-button>
                <base-button tag="span" @click="fetchUser"
                             type="secondary" class="m-1 mt-4">
                    {{language.lang('Discard')}}
                </base-button>
            </div>
        </v-container>
    </v-form>
</template>
<script>
    import language from "@/utils/language";
    import oracle from "@/utils/oracle";

    export default {
        name: "EditeProfile",
        data() {
            return {
                language: language,
                oracle: oracle,
                isEN: oracle.isEN(),
                user: null
            };
        },
        methods: {
            editProfile() {
                const model = {
                    user_profile: {
                        bio: this.user.user_profile.bio,
                        birthday: this.user.user_profile.birthday,
                        gender: this.user.user_profile.gender
                    },
                    username: this.user.username,
                    password: oracle.MD5(this.user.password)
                };
                oracle.axios("user/edit", model, (res) => {
                    oracle.showMessage(res.message, null, null, 'checked');
                });
            }, fetchUser() {
                oracle.axios("user/getProfile", {}, (res) => {
                    if (res.data.user_profile == null) {
                        res.data.user_profile = {
                            "bio": "",
                            "birthday": "",
                            "gender": 0
                        };
                    }
                    this.user = res.data;
                });
            }
        },
        mounted() {
            this.fetchUser()
        },
    };
</script>
<style>
</style>
